import * as React from "react";

const getYoutubeId = (url) => {
  let id = "";
  url = url
    .replace(/(>|<)/gi, "")
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (url[2] !== undefined) {
    id = url[2].split(/[^0-9a-z_-]/i);
    id = id[0];
  } else {
    id = url;
  }
  return id;
};

const Video = ({ video, intro }) => {
  if (!video) return null;

  const id = getYoutubeId(video.url);

  const params = new URLSearchParams({
    rel: "0",
    autoplay: "0",
    mute: "0",
    loop: "1",
    playlist: id,
    playsinline: "1",
    controls: "0",
  });

  return (
    <div className="video">
      <div className="container">
        {intro && (
          <div className="video-intro">
            <h2 className="heading heading-large">{intro}</h2>
          </div>
        )}
        <figure>
          <iframe
            src={`https://www.youtube.com/embed/${id}?${params.toString()}`}
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Youtube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            width="560"
            height="315"
          ></iframe>
        </figure>
      </div>
    </div>
  );
};

export default Video;
